import "core-js";
import "regenerator-runtime/runtime";
import { loadCrashPage } from "./loadCrashPage";
import { getRenderShellOptions } from "./portals";

function logVersion() {
  console.log("APP_VERSION:", `shell/${COMMIT_HASH}`);
}

async function main() {
  logVersion();
  try {
    // Start loading loadEnv file
    const configP = import(/* webpackPreload: true */ "./config");
    // Start loading the boostrap...
    const universalBoostrapP = import(
      /* webpackPreload: true */ "./universalBootstrap"
    );
    const renderShellP = import(/* webpackPreload: true */ "./renderShell");
    // Finish loading loadEnv file
    const { loadConfig } = await configP;
    // load and finish loading env...
    const config = await loadConfig();
    // Start loading renderShell
    // Finish loading the boostrap and run the bootstrap
    const { universalBootstrap } = await universalBoostrapP;

    await universalBootstrap(config);
    // Finish loading renderShell....
    const { renderShell } = await renderShellP;
    // Finish loading render options, render and finish rendering...
    await renderShell(config, getRenderShellOptions(config));
  } catch (err) {
    console.error(err);
    await loadCrashPage(err);
  }
}

main();
